import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setStartTime } from '../../../redux/personaliseLessons/timerSlice';

const useLearnTubeXTimer = () => {
    const dispatch = useDispatch();
    const startTime = useSelector((state) => state.personaliseLessons?.timer?.startTime);
    const currentTime = Date.now();
    const duration = 48 * 60 * 60 * 1000; // 48 hours in milliseconds

    const calculateRemainingTime = () => {
        if (startTime) {
            const elapsedTime = currentTime - startTime;
            const remainingTime = Math.max(duration - elapsedTime, 0);
            return remainingTime;
        }
        return duration;
    };
    
    const [remainingTime, setRemainingTime] = useState(calculateRemainingTime());

    useEffect(() => {
        if (!startTime) {
            dispatch(setStartTime(currentTime));
        }
    
        const timerInterval = setInterval(() => {
            setRemainingTime(calculateRemainingTime());
        }, 1000);
    
        return () => {
          clearInterval(timerInterval);
        };
    }, [dispatch, startTime, currentTime]);
    
    return remainingTime
};

export default useLearnTubeXTimer;
